import App from './App.svelte';



window.CreateAllCenterList = function (target, center_list, title1, title2, center_list_for_search, center_list_filter) {
	console.log("All center list", target);
	var app = new App({
		target: document.getElementById(target),
		props: {center_list:center_list, title1:title1, title2:title2, center_list_for_search:center_list_filter, temp_center_list:center_list}
	});
}
